import {
  Alert,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { FormEvent, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import HolaVidaLogo from "src/assets/HolaVidaLogo";
import { theme } from "src/assets/theme";
import LoadingButton from "src/components/Buttons/LoadingButton";
import { useIsMobile } from "src/hooks/useIsMobile";
import { supabaseClient } from "src/lib/supabase/supabaseClient";

const ResetPassword = () => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const page = "reset-password";
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const [displayAlert, setDisplayAlert] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleResetLink = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setLoading(true);

      try {
        const { error } = await supabaseClient.auth.resetPasswordForEmail(
          email,
          {
            redirectTo: `${import.meta.env.VITE_BASE_URL}/update-password`,
          }
        );

        if (error == null) {
          setDisplayAlert(true);
          setEmail("");
          setDisableButton(true);
        }
      } catch (err) {
        console.error("Unexpected error", err);
      } finally {
        setLoading(false);
      }
    },
    [email]
  );

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="100%"
      padding="1rem"
    >
      <Stack gap="3rem">
        <Box
          component="form"
          role="form"
          onSubmit={handleResetLink}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "max-contnet",
            maxWidth: "380px",
            width: isMobile ? "fit-content" : "100%",
            boxShadow: 10,
            p: isMobile ? 3 : 5.5,
            borderRadius: "12px",
            backgroundColor: "#ffffff",
          }}
        >
          <Box sx={{ alignSelf: "center" }}>
            <HolaVidaLogo
              style={{
                width: isMobile ? "145" : "180",
                height: isMobile ? "80" : "90",
              }}
            />
          </Box>
          <Stack sx={{ mt: 1 }} gap={3}>
            <Typography
              variant={isMobile ? "h6" : "h5"}
              fontWeight={700}
              width={isMobile ? "320px" : "400px"}
            >
              {t(`${page}.title`)}
            </Typography>
            <Stack gap={4}>
              <TextField
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                id="filled-adornment-email"
                label={t(`login.email.label`)}
              />
              <Stack gap={2}>
                <LoadingButton
                  loading={loading}
                  type="submit"
                  disabled={disableButton}
                >
                  {t(`${page}.send`)}
                </LoadingButton>
                <Button
                  variant="alternate"
                  sx={{ backgroundColor: theme.palette.grey[300] }}
                  onClick={() => navigate(-1)}
                >
                  {t("back")}
                </Button>
              </Stack>
              {displayAlert ? (
                <Alert severity="success">{t(`${page}.success-alert`)}</Alert>
              ) : null}
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Stack>
  );
};

export default ResetPassword;
